interface fetchNewsletterSubscriptionsProps {
    email: string;
}

interface NewsletterSubscriptionsResponse {
    isSubscriber: boolean;
    userNewsletterLists: string[] | undefined;
}

export async function fetchNewsletterSubscriptions({
    email,
}: fetchNewsletterSubscriptionsProps): Promise<NewsletterSubscriptionsResponse> {
    const url = `${
        process.env.NEXT_PUBLIC_REGISTRATION_URL
    }/api/newsletters/subscription?${new URLSearchParams({
        email,
    }).toString()}`;
    const options: RequestInit = {
        method: "GET",
        credentials: "include",
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response || !response.ok) {
        throw new Error(
            `[newsletter][fetchNewsletterSubscriptions] Request to fetch newsletter subscriptions failed with status ${response.status}`
        );
    }

    try {
        const { isSubscriber, lists } = await response.json();
        return {
            isSubscriber: Boolean(isSubscriber),
            userNewsletterLists: lists,
        } as NewsletterSubscriptionsResponse;
    } catch (e) {
        throw new Error(
            `[newsletter] [fetchNewsletterSubscriptions] Parsing Json failed: ${e}`
        );
    }
}
